// Vendor imports
const _ = require('lodash')
const React = require('react')
// Client V2 common imports
const useClientEffect = require('client-v2/common/hooks/client-effect')

const NO_CLAMPING = -1

function useLineClampFitStyle({ disabled, domRef }) {
  const [ needsRecalculation, setNeedsRecalculation ] = React.useState(true)
  const [ lineCount, setLineCount ] = React.useState(NO_CLAMPING)
  useClientEffect(
    () => {
      const el = domRef.current
      if (!disabled && el && needsRecalculation) {
        setLineCount(determineLineCount(el))
        setNeedsRecalculation(false)
      } else if (disabled) {
        setLineCount(NO_CLAMPING)
        setNeedsRecalculation(true)
      }
    },
    [ domRef, disabled, needsRecalculation, setLineCount, setNeedsRecalculation ]
  )
  useClientEffect(
    () => {
      if (disabled) {
        return
      }
      function onResize() {
        setLineCount(NO_CLAMPING)
        setNeedsRecalculation(true)
      }
      const onResizeDebounced = _.debounce(onResize, 500)
      window.addEventListener('resize', onResizeDebounced)
      return () => {
        window.removeEventListener('resize', onResizeDebounced)
        onResizeDebounced.cancel()
      }
    },
    [ disabled, setLineCount, setNeedsRecalculation ]
  )
  if (lineCount === NO_CLAMPING || isNaN(lineCount)) {
    return { } // No styles
  }
  if (lineCount === 0) {
    return { display: 'none' }
  }
  return { WebkitLineClamp: lineCount }
}

function determineLineCount(el) {
  const parentEl = el.parentElement
  const bottomY = el.offsetTop + el.offsetHeight
  // Check if the element is overflowing its parent
  if (bottomY <= parentEl.offsetHeight) {
    return NO_CLAMPING
  }
  // Count how many lines actually fit
  const computedStyle = window.getComputedStyle(el)
  const lineHeight = parseFloat(computedStyle.getPropertyValue('line-height'))
  const availableHeight = parentEl.offsetHeight - el.offsetTop
  return Math.floor(availableHeight / lineHeight)
}

module.exports = useLineClampFitStyle
